{
    "use strict";

    document.addEventListener("DOMContentLoaded", () => {
        let items = document.querySelectorAll("template.side-banner-adjust.product-adjust");
        if(items.length <= 0){
          items = document.querySelectorAll("template.side-banner-adjust");
        }
      if(items.length <= 0) return;
        const parent = document.getElementById("shopify-section-side-banner");
        if(!parent) return;
        parent.innerHTML = "";
        items.forEach(template => {
            const content = template.content.cloneNode(true);
            parent.appendChild(content);
        });
    });
}